import { AxiosResponseHeaders } from 'axios';
import { GenericObject } from '@dxb-web-ui-framework/common/types';

const sweepOrdersCancelDTOToSweepOrdersCancelAdapter = (data: GenericObject, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { sweepOrdersCancelDTOToSweepOrdersCancelAdapter };
